"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericFormatTwoDecimals = void 0;
const react_1 = __importDefault(require("react"));
const react_number_format_1 = require("react-number-format");
const NumericFormatTwoDecimals = (props) => {
    var _a;
    return (react_1.default.createElement(react_number_format_1.NumericFormat, { className: (_a = props.className) !== null && _a !== void 0 ? _a : "", displayType: "text", thousandSeparator: "'", decimalSeparator: ".", decimalScale: 2, fixedDecimalScale: true, value: props.value }));
};
exports.NumericFormatTwoDecimals = NumericFormatTwoDecimals;
